import { Box, LinearProgress } from '@mui/material'
import SensorReadingsBox from './SensorReadingsBox'
import { useAppSelector } from '../../../../redux/hook'
import KeyValue from '../../../Common/KeyValue'
import EntityTypeData from '../../../Common/EntityTypeData'
import { ISelectedAttributes } from '../../interfaces'
import { useGetAnalysisViewData } from './Hooks/useGetAnalysisViewData'
import NoDataPlaceholder from '../../../Common/NoDataPlaceholder'
import { useTranslation } from 'react-i18next'
import { ShipmentAttributes } from '../../../../constants/constants'
import { getAttributeById } from '../../../../utils/AttributeUtils'
import { IWayPointAndPeriod } from '../../../Entity/interfaces'

interface AnalysisViewProps {
    viewId: string
    selectedAttributes: ISelectedAttributes[]
    startDate: string
    endDate: string
    orgId: string
    wayPointsSegments: IWayPointAndPeriod[]
    selectedPeriod: string
}

const AnalysisView: React.FC<AnalysisViewProps> = ({
    viewId,
    selectedAttributes,
    startDate,
    endDate,
    orgId,
    selectedPeriod,
    wayPointsSegments,
}) => {
    const { t } = useTranslation()
    const { data, isFetching, isLoading } = useGetAnalysisViewData(
        orgId ?? '',
        viewId,
        selectedAttributes,
        startDate,
        endDate,
    )

    const { analysisData: sensorReadings, ...analysisInfo } = data ?? {}
    const selectedSegment = wayPointsSegments.find(
        (segment) => segment.segmentName === selectedPeriod,
    )

    const segment = selectedSegment?.segmentName || ''
    const analysisInfo2: {
        [x: string]: string
    } = segment
        ? {
              Segment:
                  selectedSegment?.type === 'transitPort'
                      ? `Trans-Shipment – ${segment}`
                      : segment,
              ...analysisInfo,
          }
        : analysisInfo

    const selfEntityAttributeData = useAppSelector(
        (state) => state.entityInstanceView.entityData?.selfEntityAttributeData,
    )

    const productEntity = getAttributeById(
        selfEntityAttributeData.attributes,
        ShipmentAttributes.ProductAttributeId,
    )
    const productEntityName = productEntity?.name
    const productEntityVlaue = productEntity?.value
    if (isFetching || isLoading) {
        return <LinearProgress />
    }
    return (
        <Box padding="10px 20px">
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '10px',
                    flexDirection: 'column',
                    gap: '10px',
                }}
            >
                {productEntityVlaue && (
                    <KeyValue
                        name={t(productEntityName || '')}
                        value={
                            <EntityTypeData
                                fontSize="14px"
                                dataValue={productEntityVlaue}
                                orgId={orgId}
                            />
                        }
                        type="COMPONENT"
                        keyWidth="100px"
                    />
                )}
                {analysisInfo2 &&
                    Object.entries(analysisInfo2 ?? {})?.map(([key, value]) => (
                        <KeyValue
                            key={key}
                            name={t(key)}
                            value={value}
                            keyWidth="100px"
                        />
                    ))}
            </Box>
            <Box>
                {sensorReadings &&
                Object.entries(sensorReadings ?? {}).length > 0 ? (
                    Object.entries(sensorReadings ?? {}).map(
                        ([sensorName, sections]) => (
                            <SensorReadingsBox
                                key={sensorName}
                                header={sensorName}
                                sections={sections}
                            />
                        ),
                    )
                ) : (
                    <NoDataPlaceholder />
                )}
            </Box>
        </Box>
    )
}

export default AnalysisView
